import { render, staticRenderFns } from "./JeecgTreeTable.vue?vue&type=template&id=00c9c64c&scoped=true"
import script from "./JeecgTreeTable.vue?vue&type=script&lang=js"
export * from "./JeecgTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c9c64c",
  null
  
)

export default component.exports